module.exports = __webpack_public_path__ + "media/mypage/images/menu/spm5-85a7d7f0a83af37cd50adae1b892ebaf.png";